import Flex, { ALIGN_CLASS, GAP_CLASS } from "components/Flex";
import React from "react";

import { SECTION_STATUS_LABELS, SECTION_STATUS_ORDER } from "../../constants";
import styles from "./SectionStatusLegend.module.scss";

const SECTION_STATUS_DOT_MODIFIERS = {
  complete: styles["sectionStatusLegend__dot--complete"],
  inReview: styles["sectionStatusLegend__dot--in-review"],
  drafting: styles["sectionStatusLegend__dot--drafting"],
  notStarted: styles["sectionStatusLegend__dot--not-started"],
};

const SectionStatusLegend = () => (
  <Flex gap={GAP_CLASS.GAP_400} className={styles.sectionStatusLegend}>
    {SECTION_STATUS_ORDER.map((status) => (
      <Flex alignItems={ALIGN_CLASS.center} gap={GAP_CLASS.GAP_100} key={status}>
        <span
          className={`${styles.sectionStatusLegend__dot} ${SECTION_STATUS_DOT_MODIFIERS[status]}`}
        />
        <span className={styles.sectionStatusLegend__label}>
          {SECTION_STATUS_LABELS[status]}
        </span>
      </Flex>
    ))}
  </Flex>
);

export default SectionStatusLegend;
